import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

import Dashboard from "./Dashboard";
import PageBreadcrumbs from "./PageBreadcrumbs";
import api from "../service/api";
import { logout } from "../reducers/authSlice";
import { setError, setSuccess, setWarning } from "../reducers/appSlice";

const Page = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setError(""));
    dispatch(setSuccess(""));
    dispatch(setWarning(""));

    if (!props.disableCheckAuth) {
      api
        .checkAuth()
        .then((res) => {})
        .catch((e) => dispatch(logout()));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dashboard>
      <PageBreadcrumbs data={props.breadcrumbs} />

      <Paper elevation={0} sx={{ m: {
        xs: 1,
        sm: 1,
        md: 2
      }, border: "1px solid #e0e0e0" }}>
        {props.title ? (
          <Box sx={{ borderBottom: "1px solid #e0e0e0" }} pt={1} pb={1} pl={2}>
            <Typography variant="cuerpo">{props.title}</Typography>
          </Box>
        ) : (
          ""
        )}
        <Box
          sx={{
            m: {
              xs: 2,
              sm: 2,
              md: 3,
            },
          }}
        >
          {props.children}
        </Box>
      </Paper>
    </Dashboard>
  );
};

Page.propTypes = {
  disableCheckAuth: PropTypes.bool.isRequired,
};

Page.defaultProps = {
  disableCheckAuth: false,
};

export default Page;